import React, { Component } from 'react';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import {
    MenuItem,
    Grid,
    Box,
    Card,
    TextField,
    Table,
    TableRow,
    TableBody,
    TableCell,
    Typography
} from '@mui/material';
import _ from 'lodash';
import { connect } from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import moment from 'moment';
import { LoadingButton } from '@mui/lab';
import { updateCarDetail } from '../../actions/carDetailsAction';


const useStyles = makeStyles({
    root: {
        minWidth: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    card: {
        maxWidth: "100%",
        width:"auto",
        minHeight: "100%",
        display: "flex",
        alignItems: "center",
        padding:"10px",
        textAlign:"left"
    }
});


function UpdateCarDetail(props) {
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [telephoneError, setTelephoneError ] = useState('');
    const [chasisError, setChasisError ] = useState('');
    const [engineError, setEngineError ] = useState('');

    useEffect(() => {
        setIsLoading(false);
    }, [props.alerts]);

    const AddSchema = Yup.object().shape({
        buyer_name: Yup.string().required('Buyer_Name is required'),
        id_no: Yup.string().required('Id no is required'),
        po_box: Yup.string().required('Po Box is required'),
        telephone: Yup.string().required('Telephone is required'),
        model: Yup.string().required('Model is required'),
        motor: Yup.string().required('Motor is required'),
        chasis_no: Yup.string().required('Chasis no is required'),
        engine_no: Yup.string().required('Engine no is required'),
        reg_no: Yup.string().required('Reg no is required'),
        color: Yup.string().required('Color is required'),
        cc: Yup.string().required('CC is required'),
        agreed_price: Yup.number().positive().min(1,"Agreed Price should be greater than 0").required('Agreed Price is required'),
        deposite_price: Yup.number().positive().min(1,"Deposite Price should be greater than 0").required('Deposite Price is required'),
        balance: Yup.string().required('Balance is required')
    });

    const formik = useFormik({
        initialValues: {
            car_detail_id:props.car.id,
            buyer_name:props.car.buyer_name,
            id_no:props.car.id_no,
            po_box:props.car.po_box,
            telephone:props.car.telephone,
            model:props.car.model,
            motor:props.car.motor,
            chasis_no:props.car.chasis_no,
            engine_no:props.car.engine_no,
            reg_no:props.car.reg_no,
            color:props.car.color,
            cc:props.car.cc,
            agreed_price:props.car.agreed_price,
            deposite_price:props.car.deposite_price,
            balance:props.car.balance,
        },
    validationSchema: AddSchema,
        onSubmit: (values, {resetForm}) => {
            resetForm();
            setIsLoading(true);
            values.car_detail_id = props.car.id;
            props.updateCarDetail(values);
        }
    });

    useEffect(() => {
        setIsLoading(false);
        if(!_.isEmpty(props.alerts.errors)) {
            setTelephoneError(props.alerts.errors.telephone);
            setEngineError(props.alerts.errors.engine_no);
            setChasisError(props.alerts.errors.chasis_no);
        }
        if(props.alerts.status == 'success') {
            props.onDismis();
        }
    }, [props.alerts]);

    useEffect(() => {
        if(values.agreed_price && values.deposite_price) {
            var balance = values.agreed_price-values.deposite_price;
            values.balance = balance;
        } else {
            values.balance = 0;
        }
    });

    const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = formik;

    return (
        <Grid
            container
            className={classes.root}
            spacing={0}
            alignItems="center"
            justify="center"
        >
            <Card className={classes.card}>
                <FormikProvider value={formik}>
                    <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                        <fieldset style={{padding:"20px",border:"1px solid #c29136"}}>
                            <legend style={{padding:"10px"}}>Buyer Details</legend>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Buyer Name*"
                                            {...getFieldProps('buyer_name')}
                                            error={Boolean(touched.buyer_name && errors.buyer_name)}
                                            helperText={touched.buyer_name && errors.buyer_name}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Id no*"
                                            {...getFieldProps('id_no')}
                                            error={Boolean(touched.id_no && errors.id_no)}
                                            helperText={touched.id_no && errors.id_no}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Po Box*"
                                            {...getFieldProps('po_box')}
                                            error={Boolean(touched.po_box && errors.po_box)}
                                            helperText={touched.po_box && errors.po_box}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Telephone no*"
                                            {...getFieldProps('telephone')}
                                            error={Boolean(touched.telephone && errors.telephone)}
                                            helperText={touched.telephone && errors.telephone}
                                        />
                                        <Typography sx={{ color: "red" }}>{telephoneError}</Typography>
                                    </Grid>
                                </Grid>
                        </fieldset>
                        <fieldset style={{padding:"20px",border:"1px solid #c29136"}}>
                            <legend style={{padding:"10px"}}>Vehical Detail</legend>
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Model*"
                                            {...getFieldProps('model')}
                                            error={Boolean(touched.model && errors.model)}
                                            helperText={touched.model && errors.model}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Motor*"
                                            {...getFieldProps('motor')}
                                            error={Boolean(touched.motor && errors.motor)}
                                            helperText={touched.motor && errors.motor}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Chasis no*"
                                            {...getFieldProps('chasis_no')}
                                            error={Boolean(touched.chasis_no && errors.chasis_no)}
                                            helperText={touched.chasis_no && errors.chasis_no}
                                        />
                                        <Typography sx={{ color: "red" }}>{chasisError}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Engine no*"
                                            {...getFieldProps('engine_no')}
                                            error={Boolean(touched.engine_no && errors.engine_no)}
                                            helperText={touched.engine_no && errors.engine_no}
                                        />
                                        <Typography sx={{ color: "red" }}>{engineError}</Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Reg no*"
                                            {...getFieldProps('reg_no')}
                                            error={Boolean(touched.reg_no && errors.reg_no)}
                                            helperText={touched.reg_no && errors.reg_no}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Color*"
                                            {...getFieldProps('color')}
                                            error={Boolean(touched.color && errors.color)}
                                            helperText={touched.color && errors.color}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="CC*"
                                            {...getFieldProps('cc')}
                                            error={Boolean(touched.cc && errors.cc)}
                                            helperText={touched.cc && errors.cc}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Agreed Price*"
                                            {...getFieldProps('agreed_price')}
                                            error={Boolean(touched.agreed_price && errors.agreed_price)}
                                            helperText={touched.agreed_price && errors.agreed_price}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            type="text"
                                            label="Deposite Price*"
                                            {...getFieldProps('deposite_price')}
                                            error={Boolean(touched.deposite_price && errors.deposite_price)}
                                            helperText={touched.deposite_price && errors.deposite_price}
                                        />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            disabled
                                            type="text"
                                            label="Balance*"
                                            {...getFieldProps('balance')}
                                            error={Boolean(touched.balance && errors.balance)}
                                            helperText={touched.balance && errors.balance}
                                        />
                                    </Grid>
                                </Grid>
                            </fieldset>
                            <LoadingButton
                                size="medium"
                                type="submit"
                                variant="contained"
                                loading={isLoading}
                                sx={{backgroundColor: '#c29136',float:"right", marginTop:"30px"}}
                                onClick={handleSubmit}
                            >
                                Update
                            </LoadingButton>
                    </Form>
                </FormikProvider>
            </Card>
        </Grid>
    )
}

const mapStateToProps = state => {
    return {
        alerts: state.alerts
    }
}

export default connect(mapStateToProps, { updateCarDetail })(UpdateCarDetail);

